import { FlyoutFunction } from '../../productsListing/types'
import {
  clearPrivateOffers,
  setPageNumber as setPageNumberForPrivateOffers,
} from '../../privateOffer/action'
import {
  clearAllRevenueData,
  setPageOneForRevenue,
} from '../../revenueInsights/action'
import {
  clearRevenueReports,
  setPageOneForRevenue as setPageOneForRevenueV2,
} from '../../revenueInsightsV2/action'
import {
  clearSubscriptions,
  setPageNumber as setPageNumberForSubscriptions,
} from '../../subscription/action'
import type { CloudProductFilters } from '../types'
import {
  clearResaleAuthorizations,
  setResaleAuthorizationsPageNumber,
} from './resaleAuthorizationFilterActions'

export const CloudProductFilterConstructor = (functionType: FlyoutFunction) => {
  switch (functionType) {
    case FlyoutFunction.REVENUE:
      return getCloudProductFilterRevenueActionsV2
    case FlyoutFunction.PRIVATE_OFFERS:
      return getCloudgetCloudProductFilterPrivateOfferActions
    case FlyoutFunction.RESALE_AUTHORIZATIONS:
      return getCloudProductFilterResaleActions
    case FlyoutFunction.SUBSCRIPTION:
      return getCloudProductFilterSubscriptions
    default:
      return getCloudProductFilterRevenueActions
  }
}

const getCloudProductFilterResaleActions: () => CloudProductFilters = () => ({
  clearData: clearResaleAuthorizations,
  setPageAsOne: () => setResaleAuthorizationsPageNumber(1),
})

const getCloudProductFilterRevenueActions: () => CloudProductFilters = () => ({
  clearData: clearAllRevenueData,
  setPageAsOne: setPageOneForRevenue,
})

const getCloudProductFilterRevenueActionsV2: () => CloudProductFilters =
  () => ({
    clearData: clearRevenueReports,
    setPageAsOne: setPageOneForRevenueV2,
  })

const getCloudProductFilterSubscriptions: () => CloudProductFilters = () => ({
  clearData: clearSubscriptions,
  setPageAsOne: () => setPageNumberForSubscriptions(1),
})

const getCloudgetCloudProductFilterPrivateOfferActions: () => CloudProductFilters =
  () => ({
    clearData: clearPrivateOffers,
    setPageAsOne: () => setPageNumberForPrivateOffers(1),
  })
